export enum UndefinedAppointmentTimes {
  Blank = '',
  TBD = 't_b_d',
  ASAP = 'asap'
}
